import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { useTranslation } from 'react-i18next';
import { AnimalType } from '../models/animal';
import { HealthSystemDALEnumsAnimalType } from '../api/HealthSystemApi';

interface AnimalTypeSelectProps {
  value: number;
  onAnimalTypeChange: (value: HealthSystemDALEnumsAnimalType) => void;
  cssClass?: string;
  fullWidth?: boolean;
  allowAny?: boolean;
  labelText?: string;
}

const AnimalTypeSelect = ({
  value,
  onAnimalTypeChange,
  cssClass,
  fullWidth,
  allowAny,
  labelText
}: AnimalTypeSelectProps) => {
  const { t } = useTranslation();

  const handleAnimalTypeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const animalTypeValue = event.target.value as HealthSystemDALEnumsAnimalType;

    //callback
    onAnimalTypeChange(animalTypeValue);
  };

  return (
    <FormControl className={cssClass} variant="outlined" fullWidth={fullWidth} size="small">
      <InputLabel id="animalTypeLabel">{labelText || t('f-com-animal-type')}</InputLabel>
      <Select
        label={t('f-com-animal-type')}
        labelId="animalTypeLabel"
        id="animalTypeSelect"
        value={value}
        onChange={handleAnimalTypeChange}
      >
        {allowAny && <MenuItem value={AnimalType.Unknown}>{t('f-any')}</MenuItem>}
        <MenuItem value={AnimalType.Sow}>{t('Sow')}</MenuItem>
        <MenuItem value={AnimalType.Gilt}>{t('Gilt')}</MenuItem>
        <MenuItem value={AnimalType.Piglet}>{t('Piglet')}</MenuItem>
        <MenuItem value={AnimalType.Fattening}>{t('Fattening')}</MenuItem>
        <MenuItem value={AnimalType.Boar}>{t('Boar')}</MenuItem>
        <MenuItem value={AnimalType.Goat}>{t('Goat')}</MenuItem>
        <MenuItem value={AnimalType.Cow}>{t('Cow')}</MenuItem>
        <MenuItem value={AnimalType.Calf}>{t('Calf')}</MenuItem>
      </Select>
    </FormControl>
  );
};

export default AnimalTypeSelect;
